import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
const ModalComponent = ({ modal, toggle, movie }) => {
  return (
    <div>
      <Modal isOpen={modal} toggle={toggle} className="modal-dialog">
        <ModalHeader toggle={toggle}>{movie.name}</ModalHeader>
        <ModalBody>
          <iframe
            title={movie.name}
            width="100%"
            height="315"
            src={`https://www.youtube.com/embed/${movie.key}`}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Đóng
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ModalComponent;
